import React from 'react'

const dailySkeletonBase = {
    backgroundColor: '#e0e0e0',
    borderRadius: '4px',
    animation: 'pulse 1.5s infinite',
}

const TasksSkeleton = () => {
    return (
        <div className="home-tasks-section-container">
            {/* Header */}
            <div className="w-full">
                <div className="tasks-header" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div className="animate-pulse" style={{ width: 100, height: 25, backgroundColor: '#3c8794', borderRadius: 6 }} />
                        <div className="animate-pulse" style={{ width: 33, height: 33, backgroundColor: '#3c8794', borderRadius: '50%' }} />
                    </div>
                    <div className="animate-pulse" style={{ width: 90, height: 25, backgroundColor: '#3c8794', borderRadius: 6 }} />
                </div>
                <div className="tasks-subheader" style={{ marginTop: '40px', marginBottom: '10px' }}></div>
            </div>
            <div className="task-content scrollbar-none">
                <div className="all-tasks-container ">
                    {/* Daily Emotions */}
                    <div
                        style={{
                            width: '100%',
                            background: '#4eacaa',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderRadius: '10px',
                            flexDirection: 'column',
                            gap: '12px',
                            minHeight: '199px',
                        }}
                    >
                        {/* Title Section */}
                        <div style={{ width: '100%', padding: '15px 35px 0 35px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '0 20px' }}>
                                <div style={{ ...dailySkeletonBase, height: '20px', width: '50%' }} />
                                <div style={{ ...dailySkeletonBase, height: '16px', width: '70%' }} />
                            </div>
                        </div>

                        {/* Emotions Section */}
                        <div style={{ width: '100%', height: '120px', position: 'relative' }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: 7,
                                    left: 0,
                                    right: 0,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    padding: '0 15px',
                                }}
                            >
                                {/* Left arrow */}
                                <div
                                    style={{
                                        marginTop: 20,
                                        width: 30,
                                        height: 30,
                                        borderRadius: '50%',
                                        border: '5px solid #3c8794',
                                        backgroundColor: '#4eacaa',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                />

                                {/* Emotion placeholders */}
                                <div style={{ display: 'flex', gap: '12px', paddingTop: 15 }}>
                                    {Array.from({ length: 4 }).map((_, i) => (
                                        <div className="animate-pulse" key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <div style={{ ...dailySkeletonBase, width: '54px', height: '54px', borderRadius: '50%' }} />
                                            <div style={{ ...dailySkeletonBase, width: '50px', height: '14px', marginTop: '6px' }} />
                                        </div>
                                    ))}
                                </div>

                                {/* Right arrow */}
                                <div
                                    style={{
                                        marginTop: 20,
                                        width: 30,
                                        height: 30,
                                        borderRadius: '50%',
                                        border: '5px solid #3c8794',
                                        backgroundColor: '#4eacaa',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                />
                            </div>

                            {/* Footer gradient */}
                            <div
                                style={{
                                    marginTop: '50px',
                                    width: '100%',
                                    height: '50%',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.53) 0%, rgba(255, 255, 255, 0) 100%)',
                                }}
                            />
                        </div>
                    </div>

                    {/* Daily Feedback */}
                    <div
                        style={{
                            marginTop: 20,
                            display: 'flex',
                            flexDirection: 'column',
                            background: '#4eacaa',
                            borderRadius: '10px',
                            padding: '15px 15px 0px 20px',
                            minHeight: '83px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '15px',
                            }}
                        >
                            <div
                                className="animate-pulse"
                                style={{
                                    height: '20px',
                                    width: '110px',
                                    backgroundColor: '#3c8794',
                                    borderRadius: '4px',
                                }}
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                paddingRight: 30,
                            }}
                        >
                            <div
                                className="animate-pulse"
                                style={{
                                    height: '25px',
                                    width: '170px',
                                    backgroundColor: '#3c8794',
                                    borderRadius: '4px',
                                }}
                            />
                            <div
                                className="animate-pulse"
                                style={{
                                    height: '40px',
                                    width: '40px',
                                    backgroundColor: '#3c8794',
                                    borderRadius: '50%',
                                }}
                            />
                        </div>
                    </div>

                    {/* Task Item 1 - Poll */}
                    <div
                        style={{
                            backgroundColor: 'white',
                            borderRadius: 12,
                            padding: 16,
                            marginTop: 16,
                            marginBottom: 16,
                            color: '#000',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                        }}
                    >
                        <div className="animate-pulse" style={{ width: '50%', height: 14, backgroundColor: '#ccc', borderRadius: 4 }} />
                        <div className="animate-pulse" style={{ width: '100%', height: 160, backgroundColor: '#ddd', borderRadius: 8 }} />
                        <div className="animate-pulse" style={{ width: '60%', height: 14, backgroundColor: '#ccc', borderRadius: 4 }} />
                        {Array.from({ length: 3 }).map((_, i) => (
                            <div className="animate-pulse" key={i} style={{ width: '100%', height: 36, backgroundColor: '#eee', borderRadius: 6 }} />
                        ))}
                        <div className="animate-pulse" style={{ width: '40%', height: 30, backgroundColor: '#ccc', borderRadius: 6 }} />
                    </div>

                    {/* Task Item 2 - Open Question */}
                    <div
                        style={{
                            backgroundColor: 'white',
                            borderRadius: 12,
                            padding: 16,
                            marginBottom: 16,
                            color: '#000',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                        }}
                    >
                        <div className="animate-pulse" style={{ width: '50%', height: 14, backgroundColor: '#ccc', borderRadius: 4 }} />
                        <div className="animate-pulse" style={{ width: '100%', height: 28, backgroundColor: '#ddd', borderRadius: 6 }} />
                        <div className="animate-pulse" style={{ width: '100%', height: 60, backgroundColor: '#eee', borderRadius: 8 }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TasksSkeleton
